var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBloodicongray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4366 0.186364C12.2183 -0.0621213 11.7892 -0.0621213 11.5709 0.186364C11.0966 0.736043 0 13.6874 0 20.0878C0 26.6538 5.38269 32 12 32C18.6173 32 24 26.6538 24 20.0878C24.0075 13.6874 12.9109 0.736043 12.4366 0.186364ZM12 30.863C6.01506 30.863 1.13677 26.0288 1.13677 20.0953C1.13677 14.7943 9.92221 3.93623 12 1.45137C14.0703 3.93623 22.8632 14.7943 22.8632 20.0953C22.8632 26.0288 17.9925 30.863 12 30.863Z",
    fill: "#CED5D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6667 14H10.3333V17.3333H7V20.6667H10.3333V24H13.6667V20.6667H17V17.3333H13.6667V14ZM15.8889 18.4371V19.5483H12.5556V22.8816H11.4445V19.5483H8.11113V18.4371H11.4445V15.1038H12.5556V18.4371H15.8889Z",
    fill: "#CED5D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9134 7.2422C14.7619 6.99061 14.4524 6.9259 14.2219 7.09123C13.9914 7.25656 13.9321 7.5944 14.0836 7.84599L17.0866 12.7556C17.1854 12.9137 17.3435 13 17.5015 13C17.5937 13 17.6925 12.9712 17.7781 12.9065C18.0086 12.7412 18.0679 12.4033 17.9164 12.1517L14.9134 7.2422Z",
    fill: "#CED5D8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloodicongray);
export default __webpack_public_path__ + "static/media/bloodicongray.781dfb4f8e6a29527593994e01b8edb1.svg";
export { ForwardRef as ReactComponent };